module.exports = __webpack_public_path__ + "static/media/Ih.061364d4.jpg";